interface ShowingNavs {
  navHead: number
  navEnd: number
}

interface DisplayPageRange {
  indexes: number[]
  showPrev: boolean
  showNext: boolean
}

export default class Pagenation {
  /**
 * showingの値を設定する
  @param head: ページ先頭
  @param length: 表示させるリストの長さ
  @param size: 1ページに表示する個数
  @param navhead: showing の min
  @param navend: showing の max
 */
  public setShowing(
    head: number,
    length: number,
    size: number,
    navhead: number,
    navend: number): ShowingNavs {
    const maxcount = length
    // head
    if (maxcount > 0) {
      // 配列は0開始のためShowingは+1する
      navhead = head + 1
    } else {
      navhead = 0
    }
    // end
    if (head + size > maxcount) {
      // 最終ページのend
      navend = length
    } else {
      navend = head + size
    }
    // 開始 <= 終了の関係を維持
    if (navhead > navend) {
      navhead = navend
    }
    const navs = { navHead: navhead, navEnd: navend }
    return navs
  }

  /**
 * prevボタンクリック時の処理
 */
  public prev(currentPage: number): number {
    if (currentPage > 0) {
      currentPage--
    }
    return currentPage
  }

  /**
 * nextボタンクリック時の処理
 */
  public next(currentPage: number, pages: number): number {
    if (currentPage < pages - 1) {
      currentPage++
    }
    return currentPage
  }

  /**
   * ページ番号クリック時の処理
   */
  public pageSelect(currentPage: number, index: number): number {
    currentPage = index - 1
    return currentPage
  }

  /**
   * ページネーションで表示するページ番号の範囲を取得する
   */
  public displayPageRange(
    pageRange: number,
    pages: number,
    currentPage: number,
    showprev: boolean,
    shownext: boolean
  ): DisplayPageRange {
    const half = Math.ceil(pageRange / 2)
    let start, end

    showprev = false
    shownext = false

    if (pages < pageRange) {
      // ページネーションのrangeよりページ数がすくない場合
      start = 1
      end = pages
    } else if (currentPage < half) {
      // 左端のページ番号が1になったとき
      start = 1
      end = start + pageRange - 1
    } else if (pages - half <= currentPage) {
      // 右端のページ番号が総ページ数になったとき
      end = pages
      start = end - pageRange + 1
    } else {
      // activeページを中央にする
      start = currentPage - half + 1
      end = currentPage + half
    }
    showprev = !(currentPage + 1 === 1)
    shownext = currentPage + 1 !== pages

    const indexes: number[] = []
    for (let i = start; i <= end; i++) {
      indexes.push(i)
    }
    const result = { indexes: indexes, showPrev: showprev, showNext: shownext }
    return result
  }
}

// const selectHandler = () => {
//   // 何か必要な処理があれば
// }
